<script>
import { isEqual } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import ActionFooter from '@components/footer/action-footer.vue';
import PhotoUploader from '@components/uploaders/photo-uploader.vue';
import { helperMixin } from '@mixins/helper-mixin';
import { platelistModelMixin } from '@mixins/models/platelist-model-mixin';
import {
  adminPanelComputed,
  adminPanelMethods,
  authComputed,
  mediaComputed,
  platelistComputed,
  recipeComputed,
  recipeMethods,
  platelistMethods,
  mediaMethods,
} from '@state/helpers';

export default {
  components: {
    ActionFooter,
    PhotoUploader,
  },
  props: {
    content: {
      type: Object,
      required: false,
      default: null,
    },
  },
  mixins: [helperMixin, platelistModelMixin],
  data() {
    return {
      disabledBtnsOnSave: false,
      hasUnsavedChanges: false,
      initPlatelistObj: null,
      isArchiving: false,
      isDrafting: false,
      isPublishing: false,
      isFormValid: false,
      isSaving: false,
      menudPlatelistPlaceholder:
        'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
      placeholder:
        'https://res.cloudinary.com/menud/image/upload/v1568310432/Select_Plan_pmmuzt.jpg',
      platelist: {},
    };
  },
  computed: {
    ...adminPanelComputed,
    ...authComputed,
    ...mediaComputed,
    ...platelistComputed,
    ...recipeComputed,
    isAdmin() {
      return (
        this.currentUser &&
        this.currentUser.roles &&
        this.currentUser.roles.isAdmin
      );
    },
    coverPhoto() {
      return (this.platelist &&
        !this.platelist.imageurl &&
        !this.platelist.imageUrl) ||
        (this.platelist && this.platelist.imageurl === '') ||
        (this.platelist && this.platelist.imageUrl === '') ||
        (this.platelist &&
          this.platelist.imageurl === this.menudPlatelistPlaceholder) ||
        (this.platelist &&
          this.platelist.imageUrl === this.menudPlatelistPlaceholder)
        ? this.placeholder
        : this.platelist.imageUrl || this.platelist.imageurl;
    },
    selectedPlanStatus() {
      if (this.isPublished) {
        return 'publish-selected';
      } else if (this.isArchived) {
        return 'archive-selected';
      } else {
        return 'draft-selected';
      }
    },
    isArchived() {
      return this.platelist && this.platelist.archived;
    },
    isDrafted() {
      return this.platelist && this.platelist.draft;
    },
    isPublished() {
      return (
        this.platelist && !this.platelist.draft && !this.platelist.archived
      );
    },
    isNewPlatelist() {
      return this.platelist && this.platelist.id === 99999999;
    },
    authorName() {
      return this.currentUser &&
        this.isAdmin &&
        this.platelist &&
        this.platelist.payload &&
        this.platelist.payload.referrerName
        ? this.platelist.payload.referrerName
        : this.trainerFullName;
    },
    disablePublishBtn() {
      return (
        (this.isNewPlatelist && !this.hasUnsavedChanges) ||
        (!this.platelist.draft && !this.hasUnsavedChanges) ||
        this.disabledBtnsOnSave ||
        !this.isFormValid
      );
    },
    disableDraftBtn() {
      return (
        (!this.isArchived && !this.hasUnsavedChanges && !this.isFormValid) ||
        this.disabledBtnsOnSave
      );
    },
  },
  async beforeMount() {
    if (this.$route.name === 'mealPlans') {
      this.platelist = await this.$_getPlatelistModel();
    }
  },
  methods: {
    ...adminPanelMethods,
    ...mediaMethods,
    ...platelistMethods,
    ...recipeMethods,
    cancelChanges() {
      if (this.selectedPlatelist) {
        this.setSelectedPlatelist(this.initPlatelistObj);
      } else {
        this.platelist = {};
      }
      this.setHideAdminPanel();
    },
    updatePlanTitle(value) {
      this.platelist.title = value;
      this.platelist.landingpagetitle = value;
      if (this.isNewPlatelist) {
        this.platelist.payload.title = value;
        this.platelist.payload.landingPageTitle = value;
      }
      value ? (this.isFormValid = true) : (this.isFormValid = false);
    },
    updatePlanDescription(value) {
      this.platelist.description = value;
      this.platelist.landingpagedescription = value;
      if (this.isNewPlatelist) {
        this.platelist.payload.landingPageDescription = value;
        this.platelist.payload.description = value;
      }
    },
    updateMealPlanStatus(status) {
      switch (status) {
        case 'draft':
          this.platelist.draft = true;
          this.platelist.archived = false;
          break;
        case 'publish':
          this.platelist.draft = false;
          this.platelist.archived = false;
          break;
        case 'archive':
          this.platelist.draft = false;
          this.platelist.archived = true;
          break;
      }
    },
    handleSavingStatus(status, submitted) {
      this.disabledBtnsOnSave = submitted;
      switch (status) {
        case 'archive':
          this.isArchiving = submitted;
          break;
        case 'draft':
          this.isDrafting = submitted;
          break;
        case 'publish':
          this.isPublishing = submitted;
          break;
        default:
          this.isSaving = submitted;
          break;
      }
    },
    buildPlatelistPayload(status, newImgUrl = null) {
      this.updateMealPlanStatus(status);

      return {
        ...this.platelist,
        imageUrl:
          newImgUrl ||
          this.platelist.imageurl ||
          this.platelist.imageUrl ||
          this.placeholder,
        imageurl:
          newImgUrl ||
          this.platelist.imageurl ||
          this.platelist.imageUrl ||
          this.placeholder,
        shareImageUrl:
          newImgUrl ||
          this.platelist.shareImageUrl ||
          this.platelist.imageurl ||
          this.platelist.imageUrl ||
          this.placeholder,
        platelistImage:
          newImgUrl || this.platelist.platelistImage || this.placeholder,
        payload: {
          ...this.platelist.payload,
          imageUrl:
            newImgUrl ||
            this.platelist.imageurl ||
            this.platelist.imageUrl ||
            this.placeholder,
          imageurl:
            newImgUrl ||
            this.platelist.imageurl ||
            this.platelist.imageUrl ||
            this.placeholder,
          shareImageUrl:
            newImgUrl ||
            this.platelist.shareImageUrl ||
            this.platelist.imageurl ||
            this.platelist.imageUrl ||
            this.placeholder,
        },
      };
    },
    handleCreate(payload, status) {
      this.createPlatelist({ ...payload })
        .then(() => {
          this.setHideAdminPanel();
          this.handleSavingStatus(status, false);
        })
        .catch((e) => console.log(e));
    },
    handleUpdate(payload, status) {
      delete payload.payload;
      this.updatePlatelist(payload)
        .then(() => {
          this.setHideAdminPanel();
          this.handleSavingStatus(status, false);
        })
        .catch((e) => console.log(e));
    },
    async onSave(status) {
      await this.handleSavingStatus(status, true);

      if (this.isNewMediaAsset) {
        const blob = this.recipeImageBlob;
        this.uploadToCloudinary({ blob })
          .then(async (res) => {
            const payload = await this.buildPlatelistPayload(
              status,
              res.secure_url
            );
            this.isNewPlatelist
              ? await this.handleCreate(payload, status)
              : await this.handleUpdate(payload, status);
          })
          .catch((e) => console.log(e));
      } else {
        const payload = await this.buildPlatelistPayload(status);
        this.isNewPlatelist
          ? await this.handleCreate(payload, status)
          : await this.handleUpdate(payload, status);
      }
    },
  },
  watch: {
    platelist: {
      deep: true,
      handler(newVal, oldVal) {
        if (oldVal !== null) {
          this.hasUnsavedChanges = !isEqual(
            this.platelist,
            this.initPlatelistObj
          );
        }

        if (this.isNewPlatelist && !this.platelist.title) {
          this.hasUnsavedChanges = false;
        }

        this.setHasUnsavedPlatelistChanges(this.hasUnsavedChanges);
      },
    },
    isAdminPanelActive(newVal, oldVal) {
      if (newVal && this.selectedPlatelist) {
        this.platelist = cloneDeep(this.selectedPlatelist);
        this.initPlatelistObj = cloneDeep(this.selectedPlatelist);

        if (this.platelist.title) {
          this.isFormValid = true;
        }
      } else if (this.isNewPlatelist && !newVal && oldVal) {
        this.platelist = this.$_getPlatelistModel();
      }
    },
    tempPhotoPreview(newVal, oldVal) {
      if (newVal !== null) {
        this.hasUnsavedChanges = true;
        this.setHasUnsavedPlatelistChanges(true);
      }
    },
  },
};
</script>

<template>
  <form @submit.prevent="onSave">
    <div
      class="photo-wrapper"
      v-lazy:background-image="`${tempPhotoPreview || coverPhoto}`"
    />

    <div class="row mb-5">
      <div class="col">
        <label>Meal Plan Photo</label>
        <p>Must be .jpg, .jpeg, or .gif no larger than 4MB</p>
      </div>
      <div class="col btn-upload-wrapper">
        <PhotoUploader
          :hidePlaceholder="true"
          :hidePhotoPreview="true"
          :isCloudinaryPhoto="true"
          requestType="orgs"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label>Plan Title</label>
        <BaseInputText
          :value="platelist.title"
          @input="updatePlanTitle($event.target.value)"
        />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label>Author</label>
        <BaseInputText :value="authorName" :disabled="true" />
      </div>
    </div>

    <div class="row">
      <div class="col">
        <label>Description</label>
        <BaseInputTextarea
          type="textarea"
          rows="3"
          :value="platelist.description"
          @input="updatePlanDescription($event.target.value)"
        />
      </div>
    </div>

    <ActionFooter>
      <span v-if="!hasUnsavedChanges" class="saved-status" slot="actionState">
        No changes
      </span>
      <span v-if="hasUnsavedChanges" slot="secondaryAction">
        Not saved
        <span class="link-deselect" @click="cancelChanges">
          Cancel
        </span>
      </span>

      <BaseButton
        v-if="(isPublished || isDrafted) && !isNewPlatelist"
        type="button"
        class="btn-primary btn-clear"
        :disabled="disabledBtnsOnSave"
        :style="{ opacity: isArchiving || disabledBtnsOnSave ? 0.5 : 1 }"
        @click="onSave('archive')"
      >
        <BaseIcon v-if="isArchiving" name="sync" spin />
        <BaseIcon v-if="!isArchiving" name="archive" />
        Archive
      </BaseButton>
      <span
        class="divider-vertical"
        v-if="(isPublished || isDrafted) && !isNewPlatelist"
      />
      <BaseButton
        v-if="isNewPlatelist || isArchived"
        type="button"
        class="btn-primary btn-clear"
        @click="onSave('draft')"
        :disabled="disableDraftBtn"
        :style="{
          opacity: disableDraftBtn || isDrafting ? 0.5 : 1,
        }"
      >
        <BaseIcon v-if="isDrafting" name="sync" spin />
        <BaseIcon v-if="!isDrafting" name="save" />
        Save as Draft
      </BaseButton>
      <span class="divider-vertical" v-if="isNewPlatelist || isArchived" />
      <BaseButton
        v-if="isDrafted || isArchived"
        type="button"
        class="btn-primary btn-clear"
        @click="onSave('publish')"
        :disabled="disablePublishBtn"
        :style="{
          opacity: disablePublishBtn || isPublishing ? 0.5 : 1,
        }"
      >
        <BaseIcon v-if="isPublishing" name="sync" spin />
        <img src="@assets/images/icon-upload-white.svg" v-if="!isPublishing" />
        Save & Publish
      </BaseButton>
      <span
        class="divider-vertical"
        v-if="(isDrafted || isArchived) && !isNewPlatelist"
      />
      <BaseButton
        v-if="!isNewPlatelist"
        type="button"
        class="btn-primary btn-clear"
        :disabled="!hasUnsavedChanges || !isFormValid || disabledBtnsOnSave"
        @click="onSave"
        :style="{
          opacity:
            !hasUnsavedChanges || !isFormValid || isSaving || disabledBtnsOnSave
              ? 0.5
              : 1,
        }"
      >
        <BaseIcon v-if="isSaving" name="sync" spin />
        <BaseIcon v-if="!isSaving" name="save" />
        Save Meal Plan
      </BaseButton>
    </ActionFooter>
  </form>
</template>

<style lang="scss" scoped>
@import '@design';

.btn-status {
  align-items: center;
  border-radius: 999rem;
  color: white;
  display: flex;
  height: 3.8rem;
  justify-content: space-between;
  padding: 0 0.5rem;

  &.archive-selected {
    background-color: $color-red-two;

    .status-option.publish {
      color: white;
    }
  }

  &.draft-selected {
    background-color: $color-light-gray-twelve;
  }

  &.publish-selected {
    background-color: $color-button-bg;
  }

  label {
    margin-bottom: 0;

    &:not(.selected) {
      color: $color-text;

      &:hover {
        cursor: pointer;
      }
    }
  }

  .status-option {
    border-radius: 999rem;
    padding: 0.4rem 1rem;

    &.selected {
      background-color: white;
      color: $color-action;
    }

    &.draft {
      color: white;

      &.selected {
        color: $color-text;
      }
    }

    &.archive {
      color: white;

      &.selected {
        color: $color-red-two;
      }
    }
  }
}

.btn-upload-wrapper {
  display: flex;
  justify-content: flex-end;
}

.photo-wrapper {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: $base-border-radius-md;
  height: 27.6rem;
  margin-bottom: 3.2rem;
  width: 100%;
}

.action-footer-wrapper {
  padding: 0 4rem 0 0;
}
</style>
